import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8m0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7m3.8-10.9c-.2-.1-.5-.1-.7.2l-4.4 7-2.3-2.4c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L6 12q.3.3.6.3h.1c.3 0 .5-.2.7-.4l4.5-7.1c.2-.2.1-.6-.1-.7" />
  </svg>
);
const SvgCheckmarkCircle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="checkmark-circle" {...props} />;
export default SvgCheckmarkCircle;
